import { render } from "./InfoSectionComp.vue?vue&type=template&id=1c668b9f"
import script from "./InfoSectionComp.vue?vue&type=script&lang=js"
export * from "./InfoSectionComp.vue?vue&type=script&lang=js"

import "./InfoSectionComp.vue?vue&type=style&index=0&id=1c668b9f&lang=css"

import exportComponent from "C:\\Users\\stage\\NetttFormApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__